import gridSelectionViewStateStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('clearSelectedCells', function setScheduleSaveState(
) {
    gridSelectionViewStateStore().selectedCellKeys.clear();
});
